export const TIMESTAMP_TYPE_CREATED_AT = 'createdAt';
export const TIMESTAMP_TYPE_UPDATED_AT = 'updatedAt';
export const TIMESTAMP_TYPE_LAST_ACTIVITY_AT = 'lastActivityAt';

export const TIMESTAMP_TYPES = [
  TIMESTAMP_TYPE_CREATED_AT,
  TIMESTAMP_TYPE_UPDATED_AT,
  TIMESTAMP_TYPE_LAST_ACTIVITY_AT,
];
